module.exports = __webpack_public_path__ + "img/cinemaBg.bf3405bb.jpg";